var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('div',{staticClass:"wrapper"},[(!_vm.showLeftPanel)?_c('v-btn',{staticStyle:{"position":"absolute","top":"10px","left":"10px","z-index":"12"},attrs:{"fab":"","small":""},on:{"click":function () {
          this$1.$store.dispatch('jobsMonitoring/toggleLeftPanel');
        }}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.showLeftPanel ? "" : "mdi-menu"))])],1):_vm._e(),_c('JobsMonitorJobList',{class:[
        'custom-job-list',
        _vm.showLeftPanel ? 'custom-job-list-active' : 'custom-job-list-hidden' ]}),_c('JobsMonitorCoreMap',{staticClass:"custom-core-map"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }